import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Input, Modal, Typography } from 'antd';
import axios from 'axios';

const { Text } = Typography;

const RegisterFreeUser = ({ open, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    if (!open) {
      form.resetFields();
      setFeedback(null);
    }
  }, [form, open]);

  const handleSubmit = async (values) => {
    try {
      setSubmitting(true);
      setFeedback(null);

      const res = await axios.post(
        'https://app-swingervip-production.up.railway.app/api/admin/users/free',
        values
      );

      setFeedback({
        type: 'success',
        message: res.data.message || 'Usuario gratis registrado correctamente.',
      });
      onSuccess?.(res.data.usuario);
      form.resetFields();
    } catch (error) {
      setFeedback({
        type: 'error',
        message:
          error.response?.data?.message || 'No se pudo registrar el usuario gratis.',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Registrar usuario gratis"
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnHidden
      width={720}
      className="admin-register-modal"
    >
      <Text type="secondary">
        Creá usuarios manualmente desde el panel y dejalos activos desde el alta.
      </Text>

      {feedback ? (
        <Alert
          style={{ marginTop: 20, marginBottom: 20 }}
          type={feedback.type}
          message={feedback.message}
          showIcon
        />
      ) : null}

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        style={{ marginTop: 24 }}
      >
        <Form.Item
          label="Nombre"
          name="nombre"
          rules={[{ required: true, message: 'Ingresá el nombre.' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Apellido"
          name="apellido"
          rules={[{ required: true, message: 'Ingresá el apellido.' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Correo electrónico"
          name="correo_electronico"
          rules={[
            { required: true, message: 'Ingresá el correo electrónico.' },
            { type: 'email', message: 'El correo no es válido.' },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Contraseña"
          name="contraseña"
          rules={[
            { required: true, message: 'Ingresá una contraseña.' },
            { min: 6, message: 'La contraseña debe tener al menos 6 caracteres.' },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item label="Teléfono" name="telefono">
          <Input />
        </Form.Item>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="primary" htmlType="submit" loading={submitting}>
            Registrar usuario gratis
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default RegisterFreeUser;
